import React, { useMemo } from "react";

const AdditionalInfo = ({ innerHtml = "" }) => {
  const lines = useMemo(() => {
    if (!innerHtml) return [];
    
    // Extract text from HTML
    const text = innerHtml
      .replace(/<[^>]*>/g, ' ')
      .replace(/&[a-z]+;/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    
    if (!text) return [];
    
    // Split by periods, exclamation marks, or question marks
    return text
      .split(/(?<=[.!?])\s+/)
      .map(line => line.trim())
      .filter(line => line.length > 0);
  }, [innerHtml]);

  if (lines.length === 0) {
    return (
      <div style={{ width: "100%", backgroundColor: "white", textAlign: "right" }}>
        <div dangerouslySetInnerHTML={{ __html: innerHtml }} />
      </div>
    );
  }

  return (
    <div style={{ width: "100%", backgroundColor: "white", textAlign: "right", direction: "rtl" }}>
      {lines.map((line, index) => (
        <div
          key={index}
          style={{
            marginBottom: "10px",
            padding: "8px 0",
            borderBottom: index < lines.length - 1 ? "1px solid #e5e5e5" : "none",
            fontSize: "14px",
            lineHeight: "1.7",
            color: "#333",
          }}
        >
          {line}
        </div>
      ))}
    </div>
  );
};

export default AdditionalInfo;
